import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

const { logError } = require('../../../lib/bputils').default;

class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    hasError: PropTypes.bool,
  }

  static defaultProps = {
    hasError: false,
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  state = {
    hasError: this.props.hasError || false,
  }

  componentDidCatch(error, errorInfo) {
    logError({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.errorBoundary}>
          <div className={styles.content}>
            <div>
              <img className={styles.icon} src="/images/app/warning.svg" alt="Error" />
            </div>
            <div className={styles.message}>Oops! Something went wrong.</div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
